<template>
  <section class="admin-content " id="contact-search">
    <main class="admin-main">
       <div class="bg-dark m-b-30">
           <div class="container">
               <div class="row p-b-60 p-t-10">
                   <div class="col-md-6 text-center mx-auto text-white p-b-30">
                       <div class="m-b-10">
                           <div class="avatar ">
                               <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                           </div>
                       </div>
                       <h3 class="h3">Enrollee Registration</h3>
                   </div>

               </div>
           </div>
       </div>
       <section class="pull-up">
           <div class="container">

               <div class="row list">
                   <div class="col-lg-12">
                       <div class="card m-b-30">
                           <div class="card-header">

                             <!-- <h3 class="p-t-10 searchBy-name">Add Employee</h3> -->
                           </div>

                           <div class="card-body">
                               <div class="text-center">

                                   <h1 > <strong>Bio Data</strong> </h1>
                               </div>
                                                        <div class="form-row">
                                                          <div class="col-md-12">
                                                              <div class="form-group">
                                                                <label for="inputCity">Select Sector</label>
                                                                    <select class="form-control"  v-model="sector" >
                                                                     <option  value="formal">Formal Sector</option>
                                                                     <option  value="informal">Informal Sector</option>
                                                                 </select>
                                                              </div>
                                                          </div>


                                                            <div class="col-md-12" v-if="sector == 'informal' " >
                                                                <div class="form-group">
                                                                  <label for="inputCity">Select Informal Sector</label>
                                                                      <select class="form-control"  v-model="register.sector" >
                                                                       <option  value="Vulnerable Groups">Basic Healthcare Provision Fund</option>
                                                                       <option  value="Oganized Private Sector Plan">Oganized Private Sector Plan</option>
                                                                       <option  value="Voluntary Contributor">Voluntary Contributor</option>
                                                                       <option  value="Organized Community Healthcare Plan">Organized Community Healthcare Plan</option>
                                                                   </select>
                                                                </div>
                                                            </div>

                                                            <div class="col-md-12" v-if="sector == 'formal' " >
                                                                <div class="form-group">
                                                                  <label for="inputCity">Select Formal Sector</label>
                                                                      <select class="form-control"  v-model="register.sector" >
                                                                       <option  value="State Civil Servant Healthcare Plan">State Civil Servant Healthcare Plan</option>
                                                                       <option  value="LGA Civil Servant Healthcare Plan">LGA Civil Servant Healthcare Plan </option>
                                                                       <option  value="Universal Basic Education Board Healthcare Plan">Universal Basic Education Board Healthcare Plan</option>
                                                                       <option  value="State Pensioneers Healthcare Plan">State Pensioneers Healthcare Plan</option>
                                                                       <option  value="LGA Pensioneers Healthcare Plan">LGA Pensioneers Healthcare Plan</option>
                                                                       <option value="Tertiary Student Health Insurance Plan (T-SHIP)">Tertiary Student Health Insurance Plan (T-SHIP)</option>
                                                                   </select>
                                                                </div>
                                                            </div>
                                                            <div class="form-group col-md-12"  v-if="sector == 'informal'">
                                                              <label >Category of Vulnerable Groups</label>
                                                                <select class="form-control" v-model="register.category_of_vulnerable_group">
                                                                  <option  value="Pregnant Women">Pregnant Women</option>
                                                                  <option  value="Children">Children</option>
                                                                  <option  value="Aged">Aged</option>
                                                                  <option  value="IDP">IDP</option>
                                                                  <option  value="People with Special Needs">People with Special Needs</option>
                                                                  <option  value="Poorest of the Poor">Poorest of the Poor</option>
                                                               </select>
                                                            </div>




                                                             <div class="form-group col-md-6">
                                                                 <label for="inputEmail4">NIN Number</label>
                                                                 <input type="text" class="form-control" v-model="register.nimc_number" placeholder="NIN Number">
                                                             </div>
                                                             <div class="form-group col-md-6">
                                                                 <label for="inputPassword4">Surname</label>
                                                                 <input type="text" class="form-control" v-model="register.lastname"  placeholder="Last Name">
                                                             </div>
                                                             <div class="form-group col-md-6">
                                                                 <label for="inputEmail4">First Name</label>
                                                                 <input type="text" class="form-control" v-model="register.firstname" placeholder="First Name">
                                                             </div>

                                                             <div class="form-group col-md-6">
                                                                 <label for="inputPassword4">Middle Name</label>
                                                                 <input type="text" class="form-control" v-model="register.middlename"  placeholder="Last Name">
                                                             </div>

                                                         </div>

                                                         <div class="form-row">
                                                           <div class="form-group col-md-6">
                                                             <p>  <label for="inputPassword4">Date of Birth</label></p>
                                                               <date-picker v-model="register.dob" valueType="format"></date-picker>
                                                           </div>
                                                              <div class="form-group col-md-6">
                                                                  <label for="inputEmail4">Email</label>
                                                                  <input type="email" class="form-control" v-model="register.email" placeholder="Email">
                                                              </div>

                                                              <div class="form-group col-md-6">
                                                                  <label for="inputPassword4">Phone Number</label>
                                                                  <input v-phone type="text" class="form-control" v-model="register.phone_number" placeholder="Phone Number" >
                                                              </div>
                                                              <div class="form-group col-md-6">
                                                                <label for="inputCity">Gender</label>
                                                                    <select class="form-control"  v-model="register.gender" >
                                                                     <option  value="Male">Male</option>
                                                                     <option  value="Female">Female</option>
                                                                 </select>
                                                              </div>

                                                              <div class="form-group col-md-6" v-if="sector == 'formal'">
                                                                     <label for="inputCity">Select MDA</label>
                                                                         <select class="form-control"  v-model="register.place_of_work" >
                                                                          <option  :value="mda.name" v-for="mda in mdas" v-bind:key="mda.id">{{mda.name}}</option>
                                                                      </select>
                                                               </div>

                                                              <div class="form-group col-md-6" v-if="sector == 'formal'">
                                                                  <label for="inputEmail4">Computer Number</label>
                                                                  <input type="text" class="form-control" v-model="register.salary_number" placeholder="Computer Employment Number">
                                                              </div>

                                                              <div class="form-group col-md-6" v-if="sector == 'formal'">
                                                                  <label for="inputEmail4">Grade Level/Step</label>
                                                                  <input type="text" class="form-control" v-model="register.grade_level" placeholder="Grade Level/Step">
                                                              </div>

                                                              <div class="form-group col-md-6" v-if="sector == 'formal'">
                                                                <p>  <label for="inputPassword4">Date of First Appointment</label></p>
                                                                  <date-picker v-model="register.date_of_entry" valueType="format"></date-picker>
                                                              </div>

                                                              <div class="form-group col-md-6">
                                                                <label >Marital Status</label>
                                                                  <select class="form-control" v-model="register.marital_status">
                                                                    <option  value="Married">Married</option>
                                                                    <option  value="Widow">Widow</option>
                                                                    <option  value="Single">Single</option>
                                                                    <option  value="Divorced">Seperated</option>
                                                                    <option  value="Divorced">Divorced</option>
                                                                 </select>
                                                              </div>

                                                              <div class="form-group col-md-6">
                                                                <label>Facility for Accessing Health Care</label>
                                                                  <select class="form-control" v-model="register.provider_id">
                                                                    <option  :value="provider.id" v-for="provider in providers" v-bind:key="provider.id">{{provider.agency_name}}</option>
                                                                 </select>
                                                              </div>

                                                              <div class="form-group col-md-6">
                                                                <label for="inputCity">Blood Group</label>
                                                                    <select class="form-control"  v-model="register.blood" >
                                                                     <option  value="A+">A+</option>
                                                                     <option  value="A-">A-</option>
                                                                     <option  value="B+">B+</option>
                                                                     <option  value="B-">B-</option>
                                                                     <option  value="AB+">AB+</option>
                                                                     <option  value="AB-">AB-</option>
                                                                     <option  value="O+">O+</option>
                                                                     <option  value="O-">O-</option>
                                                                 </select>
                                                              </div>

                                                              <div class="form-group col-md-6">
                                                                <label for="inputCity">LGA</label>
                                                                  <select class="form-control"  v-model="register.localgovt">
                                                                    <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">{{lga.local_name}}</option>
                                                                 </select>
                                                              </div>

                                                              <div class="form-group col-md-6">
                                                                <label >Ward</label>
                                                                <input type="text" class="form-control" v-model="register.ward" placeholder="Ward">
                                                              </div>
                                                              <div class="form-group col-md-6">
                                                                 <label for="inputAddress">Home Address</label>
                                                                 <input type="text" class="form-control" v-model="register.address" placeholder="Home Address">
                                                              </div>

                                                          </div>
                                                          <div class="form-group">
                                                             <button class="btn btn-primary btn-block btn-lg" @click="registerUser">Submit</button>
                                                          </div>

                           </div>
                       </div>
                   </div>



                   <div class="vld-parent">
                        <loading :active.sync="isLoading"
                        loader="dots"
                        :can-cancel="true"
                        :is-full-page="fullPage"></loading>
                    </div>

               </div>
           </div>

       </section>
       </main>
   </section>
</template>

<script>
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin
     import DatePicker from 'vue2-datepicker';
     // import  AddClientoffLine from './AddClientAgencyOffline.vue';
     import 'vue2-datepicker/index.css';

export default {
  components: {
    Loading, DatePicker
  },
  data(){
    return{
      isLoading: false,
      fullPage: true,
      states:"",
      providers:"",
      clients:"",
      mdas:"",
      sector:"",
      response:"",
      state:"",
      lga_states:"",
      register:{
                firstname:"",
                lastname:"",
                middlename:"",
                nimc_number:"",
                email:"",
                phone_number:"",
                type:"client",
                agency_id:"",
                state:"",
                localgovt:"",
                ward:"",
                address:"",
                blood:"",
                weight:"",
                gender:"",
                genotype:"",
                dob:"",
                salary_number:"",
                provider_id:"",
                point_of_care:"",
                sector:"",
                finger_print:"",
                place_of_work:"",
                grade_level:"",
                date_of_entry:"",
                marital_status:"",
                category_of_vulnerable_group:"",
            }
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    // this.axios.get(`/api/v1/auth/getAgencyToUser/${this.user.id}`)
    //             .then(response => {
    //                 this.clients = response.data.data
    //                 console.log(response)
    //             })
    //             .catch(error => {
    //                 console.error(error);
    //             })

  },
  methods:{

    fetchLga(){
      this.axios.get(`/api/v1/auth/lga/2683`)
                  .then(response => {
                      this.lga_states = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getProviders(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/providerAgency/4`)
                  .then(response => {
                      this.providers = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
      getMDAs(){
        this.axios.get(`/api/v1/auth/ministry`)
                    .then(response => {
                      this.mdas = response.data.data
                        console.log(response)
                    })
                    .catch(error => {
                        console.error(error);
                    })
      },
    registerUser(){
      this.user = JSON.parse(localStorage.getItem('user'))
        this.isLoading = true;
        this.axios.post('/api/v1/auth/registerProvider',{
          nimc_number: this.register.nimc_number,
          firstname: this.register.firstname,
          lastname: this.register.lastname,
          middlename: this.register.middlename,
          email: this.register.email,
          phone_number: this.register.phone_number,
          type: this.register.type,
          agency_id: 4,
          provider_id: this.register.provider_id,
          state: '2683',
          role: 0,
          password: 'euhler',
          localgovt: this.register.localgovt,
          ward: this.register.ward,
          blood: this.register.blood,
          dob: this.register.dob,
          address1: this.register.address,
          genotype: this.register.genotype,
          weight: this.register.weight,
          gender: this.register.gender,
          sector: this.register.sector,
          place_of_work: this.register.place_of_work,
          point_of_care: this.register.point_of_care,
          finger_print: this.register.finger_print,
          salary_number: this.register.salary_number,
          grade_level: this.register.grade_level,
          date_of_entry: this.register.date_of_entry,
          marital_status: this.register.marital_status,
          category_of_vulnerable_group: this.register.category_of_vulnerable_group,
          enrolled_by: this.user.id,
        })
        .then(response=>{

            console.log(response);
            this.isLoading = false;
            this.$toasted.info('Client added Successfully', {position: 'top-center', duration:3000 })
            window.location = 'https://www.zamchema.zm.gov.ng';

        })
        .catch(error=>{
            console.log(error.response)
            this.isLoading = false;
            this.response = error.response.data.errors
            if (this.response.firstname != null) {
              this.$toasted.error(`${this.response.firstname}`, {position: 'top-center', duration:3000 })

            }
            if(this.response.lastname != null) {
              this.$toasted.error(`${this.response.lastname}`, {position: 'top-center', duration:3000 })

            }
            if (this.response.phone_number != null) {
              this.$toasted.error(`${this.response.phone_number}`, {position: 'top-center', duration:3000 })

            }

        })
    }

  },
  created(){
    this.fetchLga()
    this.getMDAs()
    this.getProviders()
  }

}
</script>
